import { render, staticRenderFns } from "./Styles.vue?vue&type=template&id=2086e55e"
import script from "./Styles.vue?vue&type=script&lang=js"
export * from "./Styles.vue?vue&type=script&lang=js"
import style0 from "./Styles.vue?vue&type=style&index=0&id=2086e55e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports